import useAuthUser from './use-auth-user';

export default function useAuthRoles() {
  const { roles } = useAuthUser();
  return {
    admin: roles.includes('ROLE_ADMIN'),
    coach: roles.includes('ROLE_COACH'),
    physician:
      roles.includes('ROLE_PHYSICIAN') || roles.includes('ROLE_FOUNDER'),
  };
}
